import { GetCountries, PostHotList } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link,useNavigate } from "react-router-dom";
import { useCountry } from "../contexts/countrycodecontext.js";

const AddHotList = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const navigate = useNavigate();
  const [Countries,SetCountries]=useState([{}]);
  const userType = localStorage.getItem("usertype");

  const [type,settype] = useState([
    {statusID:"1",statusName:"Recruiter"},
    {statusID:"2",statusName:"BenchSales"}])

    const [tier,setTier] = useState([
    {tierID:"Tier 1",tierName:"Tier 1"},
    {tierID:"Tier 2",tierName:"Tier 2"},
    {tierID:"Tier 3",tierName:"Tier 3"},
])

  const onSubmit = (data, e) => {
    e.preventDefault();
    AddData(data);

  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }

  
  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const token = localStorage.getItem("jwtToken");
  const roleID = localStorage.getItem("roleID")
    const { selectedCountry} = useCountry();
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  const AddData = async(data) => {
       const params={
        "name": data.name,
     "emailId": data.emailId,
  "phone":data.phone,
  "company": data.company,
  "website":data.website,
  "country":selectedCountry,
  "type":data.type,
  "tierType":data.tierType||'Tier 2',
  "description": data.description,
  "createdBy":email,
  "userGuid": guid,
  "countryID":selectedCountry
}
apiUrl = PostHotList.APIURL;
Axios.post(apiUrl, params,
      { headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
)
      .then((result) => {
             if (result.data.message == 'Inserted successfully.') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Added Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
          navigate("/Employer/ListofStaffingContacts")

          // toast.success('Data Saving', {autoClose:5000})

        }
           else if (result.data.message == 'duplicate Record  based on EmailId.') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Staffing Contact exists!',
            showConfirmButton: false,
            timer: 5000
          })

          // toast.success('Data Saving', {autoClose:5000})

        }
        else {
          // toast.error('Issue with data format', {autoClose:5000})
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Staffing Contact exists!',
            showConfirmButton: false,
            timer: 5000
          })
        }

      }).catch(
        function (error) {
          console.log("Error" + error)
        })

  }
  
  const fetchcountries=()=>
    {
      const GetapiUrl=GetCountries.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl,
          { headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",         
          }
        }
        );
        let json = await response.json();
        SetCountries(json);
      }
      fetchJSON();
  }

  useEffect(() => {
    fetchcountries();
  }, []);
useEffect(() => {
  const uType = userType?.toLowerCase();  // <-- FIXED NAME

  if (uType === "recruiter") {
    setValue("type", "BenchSales");
  } 
  else if (uType === "bench sales") {
    setValue("type", "Recruiter");
  } 
  else {
    setValue("type", "");
  }

}, [userType, setValue]);


  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListofStaffingContacts">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Add Staffing Contact</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none", minHeight: "900px"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
          <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
         
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Name</Tooltip>)}>
                <input type="text" name="name"  {...register("name", { required: "Name Required" })} placeholder="Name" className={`form-control basic-form  ${errors.name ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.name?.message}</div>
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Email</Tooltip>)}>
                <input type="email"  name="emailId" {...register("emailId")}  placeholder="Email" className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.emailId?.message}</div> */}
              <div className="mt-4">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
                <input type="text" name="website" {...register("website")} placeholder="Website URL" className={`form-control basic-form`}/>
              </OverlayTrigger>
                 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Tier Type</Tooltip>)}>    

<select  {...register("tierType", )} className={`form-control basic-form mt-3 `} style={{height:50,borderRadius:15}}  >
<option value="">Select Tier </option>
{
tier.map((item,index)=>
{
return(

<option key={index}  value={item.tierName}>{item.tierName}</option>

);
}

)
}
</select>
</OverlayTrigger>
        </div>
        <div className="mt-4">
                              {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
                <input type="text" name="website" {...register("website")} placeholder="Company Website URL" className={`form-control basic-form`}/>
              </OverlayTrigger> */}
              {/* <div className="invalid-feedback">{errors.websiteURL?.message}</div> */}

        </div>
         </div>
         {/* <div className="mt-4"> 
      </div> */}
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="text"
                  min="0"
                  title=''
                  name="phone"
                  disabled={isDisabled}
                  {...register("phone" , { required: "Mobile Number Required" })}
                  className={`form-control basic-form ${errors.phone ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.phone?.message}</div>

             
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                <input type="text" title="" name="company" {...register("company")} placeholder="Company Name " className={`form-control basic-form`} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback">{errors.domain?.message}</div> */}
              <div className="mt-4">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Description</Tooltip>)}>
                <textarea type="text" title="" name="description" {...register("description")} placeholder="Description" className={`form-control basic-form`} />
              </OverlayTrigger>

              <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Type</Tooltip>)}>    

<select  {...register("type", { required: "Type Required" })} className={`form-control basic-form mt-3 ${errors.type ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15}}  >
<option value="">Select Type </option>
{
type.map((item,index)=>
{
return(

<option key={index}  value={item.statusName}>{item.statusName}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.type?.message}</div> }
              {/* <div className="invalid-feedback">{errors.dateOfBirth?.message}</div> */}
        </div>
        <div className="mt-4">
        {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Linkedin URL</Tooltip>)}>
                <input type="text" name="linkdinUrl" {...register("linkdinUrl")} placeholder="Linkedin URL" className={`form-control basic-form`}/>
              </OverlayTrigger> */}
              {/* <div className="invalid-feedback">{errors.linkdinUrl?.message}</div> */}

        </div>
         </div>
           </div>

          </div>
         
    
         <div className="row" style={{ marginTop: "100px" }}>
  <div className="col-12 d-flex justify-content-end gap-2">
    <button className="btn btn-primary">
      {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
      Save
    </button>
    <Link to="/Employer/ListofStaffingContacts">
      <button disabled={isSubmitting || isDisabled} className="btn btn-primary">
        Cancel
      </button>
    </Link>
  </div>
</div>

        </form>
        </div>
        </div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default AddHotList;